/**
 * 分区计量模块·第3组（src/views/DMAPartitionMetering 之 ZoneManagement / components / PipelineNew 部分）英文映射
 * 中文原文做 key，value 为英文译文；与其他 en/modules/*.js 由 src/i18n/index.js 自动合并
 */
export default {
  // ── 通用（复用全局词条，同 en-US.js / 其他 en/modules/*.js）──
  '确定': 'OK',
  '取消': 'Cancel',
  '关闭': 'Close',
  '详情': 'Details',
  '删除': 'Delete',
  '编辑': 'Edit',
  '操作': 'Action',
  '创建时间': 'Created At',
  '是': 'Yes',
  '否': 'No',
  '共{total}条': 'Total {total} records',
  '当前选择：': 'Currently selected:',
  '取消选择': 'Deselect',
  '操作成功！': 'Operation successful!',
  // ── 地图/管网信息窗体 ──
  '缩放级别': 'Zoom Level',
  '项目编码': 'Project Code',
  '拓扑编码': 'Topology Code',
  '编码': 'Code',
  '编码：': 'Code: ',
  '名称': 'Name',
  '名称：': 'Name: ',
  '类型': 'Type',
  '管线': 'Pipeline',
  '管道': 'Pipe',
  '高程': 'Elevation',
  '材质': 'Material',
  '物联数据': 'IoT Data',
  '设备编号': 'Device No.',
  '设备位置': 'Device Location',
  '压力': 'Pressure',
  '温度': 'Temperature',
  '电压': 'Voltage',
  '信号': 'Signal',
  '上报时间': 'Report Time',
  '累计用量': 'Cumulative Usage',
  '未绑定物联设备': 'No IoT device bound',
  // ── 分区管理 ──
  '选择节点': 'Select Node',
  '新增分区': 'Add District',
  '新增子分区': 'Add Sub-district',
  '父级名称': 'Parent Name',
  '分区名称': 'District Name',
  '分区编码': 'District Code',
  '分区计量': 'District Metering',
  '请输入项目名称': 'Please enter project name',
  '请输入分区名称': 'Please enter district name',
  '新增分区成功！': 'District added successfully!',
  '删除分区成功！': 'District deleted successfully!',
  '是否显示': 'Visibility',
  '显示': 'Show',
  '隐藏': 'Hide',
  '新增一级片区': 'Add Top-level District',
  '请先选择GIS区域': 'Please select a GIS area first',
  '获取区域详情失败': 'Failed to get area details',
  // ── 节点 ──
  '新增节点': 'Add Node',
  '请选择要添加的节点': 'Please select nodes to add',
  '添加节点成功': 'Nodes added successfully',
  '添加节点失败': 'Failed to add nodes',
  '删除节点成功': 'Nodes deleted successfully',
  '删除节点失败': 'Failed to delete nodes',
  '节点': 'Node',
  '节点编号': 'Node No.',
  '节点编码': 'Node Code',
  '节点名称': 'Node Name',
  '节点类型': 'Node Type',
  '区域': 'Area',
  '区域详情': 'Area Details',
  '区域名称': 'Area Name',
  '区域编码': 'Area Code',
  '区域节点列表': 'Area Node List',
  '确定删除此节点吗?': 'Are you sure to delete this node?',
  '加载中...': 'Loading...',
  // ── 区域详情表单 ──
  '片区中心': 'District Center',
  '片区颜色': 'District Color',
  '片区面积': 'District Area',
  '管网长度': 'Pipe Network Length',
  '用户数量': 'Number of Customers',
  '平均压力': 'Average Pressure',
  '管理员': 'Administrator',
  '电话': 'Phone',
  '备注': 'Remark',
  '请输入备注': 'Please enter remark',
  // ── 关联行政区域 ──
  '关联行政区域': 'Associated Administrative Area',
  '行政区域（支持多选）': 'Administrative Area (Multiple Selection)',
  '当前GIS区域：': 'Current GIS area: ',
  '（仅支持绑定三级分区）': '(Only third-level districts can be bound)',
  '请输入区域名称': 'Please enter area name',
  '已绑定区域': 'Bound Areas',
  '暂无绑定区域': 'No bound areas',
  '绑定': 'Bind',
  '绑定成功': 'Bound successfully',
  '绑定失败': 'Failed to bind',
  '解绑': 'Unbind',
  '解绑成功': 'Unbound successfully',
  '解绑失败': 'Failed to unbind',
  '确定要解绑该行政区域吗?': 'Are you sure to unbind this administrative area?',
  '请选择要绑定的行政区域': 'Please select administrative areas to bind',
  // ── 地图面板组件（概览/曲线图/告警滚动）──
  '概览': 'Overview',
  '压力计': 'Pressure Gauge',
  '水表': 'Water Meter',
  '阀门': 'Valve',
  '消防栓': 'Fire Hydrant',
  '水塔': 'Water Tower',
  '加压泵': 'Booster Pump',
  '流量计': 'Flow Meter',
  '液位计': 'Liquid Level Gauge',
  '流速': 'Flow Velocity',
  '流量': 'Flow',
  '曲线图': 'Curve Chart',
  '请输入关键字查询': 'Enter keyword to search',
  '请输入节点代码或名称': 'Enter node code or name',
  '基本信息': 'Basic Information',
  '暂无数据!': 'No data yet!',
  '告警类型': 'Alarm Type',
  '告警时间': 'Alarm Time',
  '代码': 'Code',
  '物联代码': 'IoT Code',
  '转换系数': 'Conversion Coefficient',
  '最新上报时间': 'Last Report Time',
  '上报数据': 'Reported Data',
  '表编号': 'Meter No.',
  '表端剩余金额': 'Meter Remaining Balance',
  '结算日流量': 'Settlement Daily Flow',
  '管径': 'Pipe Diameter',
  '管长': 'Pipe Length',
  '编辑成功！': 'Edited successfully!',
}
